<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// https://buefy.org/documentation/start
@import '@src/design/cutomize_buefy.scss';
@import '@src/design/global.scss';
@import '@src/design/booking.scss';

@import '@design';
</style>
<script>
import { Trans } from '@utils/translation'
import appConfig from '@src/app.config'
import { authComputed } from '@state/helpers'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  name: 'App',
  computed: {
    ...authComputed,
  },
  mounted() {
    this.initLanguage()

    window.onstorage = (e) => {
      if (e.key === 'auth.currentMember') {
        const newValue = JSON.parse(e.newValue)

        console.log('登入狀態已更新')
        this.$store.dispatch('auth/setCurrentUser', newValue)

        if (this.$route.meta.authRequired) {
          if (!this.loggedIn) {
            this.$router.push({
              name: 'login',
              query: {
                language: this.$route.query.language,
                redirectFrom: this.$route.fullpath,
              },
            })
          }
        }
      }
    }
  },
  methods: {
    /**
     * 根據使用者偏好變更語言
     */
    initLanguage() {
      this.$store.dispatch('set/setLanguage', {
        language: Trans.getUserSupportedLang(),
      })
    },
  },
}
</script>
